// Deployment note: the session secret and image tool were moved out of the repo
// after an audit. The CMS admin cookie is signed with a legacy HMAC secret.
// Do not commit secrets: use the environment at build time instead.
